import React from 'react';
import { Stack } from '@grnhse/seedling/lib/birch/layouts/stack';
import CheckboxField from '@grnhse/seedling/lib/birch/components/forms/fields/checkbox_field';
import { withLocalePrefix } from 'shared/utils/translation';

const t = withLocalePrefix('talent_matching.filter_row.priority_candidates');

export const PriorityCandidatesContent = () => {
  return (
    <Stack spacing={2} direction="column">
      <CheckboxField
        name="priorityCandidates"
        label={t('checkbox_label')}
        value="priorityCandidates"
        helperText={t('checkbox_helper_text')}
      />
    </Stack>
  );
};
